import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { useSelector } from 'react-redux';
import Routes from '../components/routes/OutsideMeetingRoutes';
import useOutsideMeetingExperienceListener from '../hooks/useOutsideMeetingExperienceListener';
import { isLoadingSelector } from '../slices/auth/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
function OutsideMeeting() {
  const isLoading = useSelector(isLoadingSelector);
  useOutsideMeetingExperienceListener();
  if (isLoading) return /*#__PURE__*/_jsx(LoadingOverlay, {
    contextual: true
  });
  return /*#__PURE__*/_jsx(Routes, {});
}
export default OutsideMeeting;